import React from 'react'

const COPY = {
  tr: {
    title: 'Bir sorun oluştu',
    body: 'İşleminiz güvenli şekilde durduruldu. Aşağıdaki hata bilgilerini kopyalayıp admin’e gönderin.',
    code: 'Hata kodu', details: 'Hata detayı', copy: 'Bilgileri kopyala', copied: 'Kopyalandı', retry: 'Yeniden dene',
  },
  ru: {
    title: 'Произошла ошибка',
    body: 'Работа была безопасно остановлена. Скопируйте информацию ниже и отправьте её администратору.',
    code: 'Код ошибки', details: 'Описание ошибки', copy: 'Скопировать данные', copied: 'Скопировано', retry: 'Повторить',
  },
  kz: {
    title: 'Қате орын алды',
    body: 'Жұмыс қауіпсіз түрде тоқтатылды. Төмендегі ақпаратты көшіріп, әкімшіге жіберіңіз.',
    code: 'Қате коды', details: 'Қате туралы ақпарат', copy: 'Ақпаратты көшіру', copied: 'Көшірілді', retry: 'Қайталау',
  },
  ua: {
    title: 'Сталася помилка',
    body: 'Роботу безпечно зупинено. Скопіюйте інформацію нижче та надішліть її адміністратору.',
    code: 'Код помилки', details: 'Відомості про помилку', copy: 'Скопіювати дані', copied: 'Скопійовано', retry: 'Повторити',
  },
}

function currentLanguage() {
  if (typeof window === 'undefined') return 'tr'
  const hashQuery = window.location.hash.split('?')[1] || ''
  const requested = new URLSearchParams(hashQuery).get('lang')?.toLowerCase()
  if (requested === 'uk') return 'ua'
  if (requested === 'kk') return 'kz'
  return COPY[requested] ? requested : 'tr'
}

function errorMessage(error) {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  try { return JSON.stringify(error) } catch (serializationError) { return 'Unknown application error' }
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null, errorCode: '', copied: false }
  }

  static getDerivedStateFromError(error) {
    return { error, errorCode: `ERR-${Date.now().toString(36).toUpperCase()}` }
  }

  componentDidMount() {
    this.handleWindowError = event => {
      if (event?.error) this.captureError(event.error)
    }
    this.handleUnhandledRejection = event => this.captureError(event?.reason || 'Unhandled promise rejection')
    window.addEventListener('error', this.handleWindowError)
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection)
  }

  componentDidCatch(error, info) {
    console.error('Application error:', error, info)
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.handleWindowError)
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection)
  }

  captureError = error => {
    console.error('Unhandled application error:', error)
    this.setState({ error, errorCode: `ERR-${Date.now().toString(36).toUpperCase()}`, copied: false })
  }

  diagnosticText = () => {
    const { error, errorCode } = this.state
    return [
      `${COPY[currentLanguage()].code}: ${errorCode}`,
      `Message: ${errorMessage(error)}`,
      `Time: ${new Date().toISOString()}`,
      `URL: ${window.location.href}`,
    ].join('\n')
  }

  copyDiagnostics = async () => {
    try {
      await navigator.clipboard.writeText(this.diagnosticText())
      this.setState({ copied: true })
    } catch (clipboardError) {
      console.error('Error details could not be copied:', clipboardError)
    }
  }

  render() {
    const { children } = this.props
    const { error, errorCode, copied } = this.state
    if (!error) return children

    const text = COPY[currentLanguage()]
    return (
      <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 20, background: '#f4f7fb', color: '#152033', fontFamily: 'Inter, system-ui, sans-serif' }}>
        <section role="alert" style={{ width: 'min(620px, 100%)', padding: 32, border: '1px solid #d7deea', borderRadius: 20, background: '#fff', boxShadow: '0 22px 60px rgba(36,56,99,.14)' }}>
          <div aria-hidden="true" style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
          <h1 style={{ margin: '0 0 10px', fontSize: 28 }}>{text.title}</h1>
          <p style={{ margin: '0 0 22px', color: '#667085', lineHeight: 1.6 }}>{text.body}</p>
          <div style={{ padding: 16, borderRadius: 12, background: '#f8fafc', border: '1px solid #e2e8f0', marginBottom: 20 }}>
            <strong>{text.code}: {errorCode}</strong>
            <div style={{ marginTop: 8, color: '#475467', overflowWrap: 'anywhere' }}><strong>{text.details}:</strong> {errorMessage(error)}</div>
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button type="button" onClick={this.copyDiagnostics} style={{ border: 0, borderRadius: 10, padding: '11px 16px', background: '#3157c8', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>{copied ? text.copied : text.copy}</button>
            <button type="button" onClick={() => window.location.reload()} style={{ border: '1px solid #d7deea', borderRadius: 10, padding: '11px 16px', background: '#fff', color: '#152033', fontWeight: 700, cursor: 'pointer' }}>{text.retry}</button>
          </div>
        </section>
      </main>
    )
  }
}
